<section class="news">
  <div class="component-content">
    <h3 class="news__title">{{headline}}</h3>
    <app-news-list></app-news-list>
  </div>
</section>
